module.exports = __webpack_public_path__ + "fonts/200a0496bcebc11df70b1771601e1a60.txt";